import React from 'react';
import './StepperStyle.css';

/**
 * Stepper component that can be aligned either horizontally or vertically.
 * 
 * @param {Array} props.steps - Array with the labels of the steps.
 * @param {number} props.currentStep - The current active step (null-based).
 * @param {function} [props.onStepChange] - Function that is called up when the user clicks on a step (only for vertical steppers).
 * @param {'horizontal'|'vertical'} props.orientation - The alignment of the stepper.
 * 
 * @returns {JSX.Element} The rendered `Stepper` component.
 */
const Stepper = ({ steps, currentStep, onStepChange, orientation }) => {
    const isVertical = orientation === 'vertical';

    return (
        <div className={`stepper ${isVertical ? 'vertical' : 'horizontal'}`}>
            {steps.map((step, index) => (
                <div key={index} className="stepper-item">
                    {index < steps.length - 1 && (
                        <div className={`stepper-line ${index < currentStep ? 'active' : ''}`}></div>
                    )}
                    <div
                        className={`stepper-circle ${index === currentStep ? 'active' : index < currentStep ? 'completed' : ''}`}
                        /*onClick={isVertical ? () => onStepChange(index) : undefined} // nur klickbar, wenn vertikal*/
                        onClick={() => onStepChange(index) } // nur klickbar, wenn vertikal
                    >
                        {index + 1}
                    </div>
                    <div className="stepper-label">{step}</div>
                </div>
            ))}
        </div>
    );
};

export default Stepper;
